import { ArrowLeftIcon } from "lucide-react";
import { useBackTarget } from "@/lib/back-navigation";
import { useT } from "../../i18n";

export function BackLink({
  href,
  label,
  history = true,
}: {
  href: string;
  label: string | undefined;
  /** A named public-browsing link on the account home stays a destination. */
  history?: boolean;
}) {
  const t = useT();
  const previous = useBackTarget();
  const canReturn = history && previous !== null && window.history.length > 1;
  const text = canReturn ? t("common.back") : label;
  return (
    <a
      href={canReturn ? previous : href}
      className="inline-flex shrink-0 items-center gap-2 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
      aria-label={text}
      onClick={(event) => {
        // Modified clicks still open the real destination in another tab.
        if (
          !canReturn ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        )
          return;
        event.preventDefault();
        window.history.back();
      }}
    >
      <ArrowLeftIcon aria-hidden="true" className="size-4" />
      <span className="hidden sm:inline">{text}</span>
    </a>
  );
}
